/**
 * StudentFlagChip — coloured pill badge for a single student flag type.
 *
 * Styling pattern mirrors CategoryTag.jsx:
 *   background: colour + '20'  (10% opacity hex suffix)
 *   color:      colour
 *   border:     colour + '40'  (25% opacity hex suffix)
 */

const StudentFlagChip = ({ flagType, onRemove, size = 'sm' }) => {
  const colour = flagType.colour || '#14b8a6';

  const style = {
    backgroundColor: `${colour}20`,
    color: colour,
    borderColor: `${colour}40`,
    borderWidth: '1px',
    borderStyle: 'solid',
  };

  const sizeClasses = size === 'md'
    ? 'px-3 py-1 text-sm'
    : 'px-2 py-0.5 text-xs';

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full font-medium ${sizeClasses}`}
      style={style}
    >
      {flagType.name}
      {onRemove && (
        <button
          type="button"
          onClick={onRemove}
          className="ml-0.5 hover:opacity-70 transition-opacity"
          aria-label={`Remove ${flagType.name} flag`}
        >
          ✕
        </button>
      )}
    </span>
  );
};

export default StudentFlagChip;
